import { render } from "./MLangToggleButton.vue?vue&type=template&id=851c00ca"
import script from "./MLangToggleButton.vue?vue&type=script&lang=ts"
export * from "./MLangToggleButton.vue?vue&type=script&lang=ts"
script.render = render

export default script